const ChevronDownIcon = (props) => {
  const { size = 24, color, stroke, onClick } = props;
  return (
    <svg
      width={size}
      height={size}
      fill={color || "none"}
      stroke={stroke || "currentColor"}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      className="w-5 h-5"
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
    </svg>
  );
};

export default ChevronDownIcon;
